import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { useDispatch } from "react-redux";

import CopyToClipboard from "./CopyToClipboard";


const DocView = (props)=>{
    const { docData, docLink } = props

    const [visble, setVisible] = useState()

    const dispatch = useDispatch()

    return (
        <div>
            <div className="flex flex-row">
                <p className='doc-no' style={{cursor: "pointer",}} onClick={() => setVisible(true)}>{docData?.docNo}</p>
                <CopyToClipboard text={docData?.docNo} />
            </div>
            <Dialog visible={visble} style={{ width: '80%', height: '80%', backgroundColor: '#f8f8f8', position:"" }} onHide={() => setVisible(false)}>
                <div style={{ width: "100%", height: '100%'}}>
                    <div style={{ width: "100%", height: '100%'}}>
                        <embed className='' src={docLink} width="100%" height="100%" />
                    </div>
                </div>
            </Dialog>
        </div> 
    )
}

export default DocView;